<div id="iframeDiv">
    <iframe id="iframe" *ngIf="urlSafe" [src]="urlSafe" allow="autoplay; fullscreen"></iframe>
</div>